<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a><span> &gt; </span>
            <router-link :to="{ path: '/HzHyal', query: { name: '行业案例' } }">行业案例</router-link>
            <i v-show="id">
                <span> &gt; </span>
                <router-link :to="{ path: '/HzHyal', query: { id: id, name: name } }">{{ this.name }}
                    <!-- <span> &gt; </span> -->
                </router-link>
            </i>
        </div>
        <!-- 控制柜分类 -->
        <div class="pos_bor kzgmain">
            <div class="side">
                <div class="side_tit">
                    <h2>恒智自控<br>industry cases</h2>
                </div>
                <div class="side_type">
                    <div v-bind:class="name == item.codeDesc ? 'hov' : ''" v-for="(item, index) in caseTList" :key="index"
                        @click="onEnterTd(index)">
                        <h3>
                            <router-link class="side_bor"
                                :to="{ path: '/HzHyal', query: { id: item.cdCode, name: item.codeDesc } }">
                                {{ item.codeDesc }}
                            </router-link>
                        </h3>
                    </div>
                </div>
                <div class="side_tit" style="margin-top: 10px;">
                    <h2>
                        在线联系：<br>
                        <!-- <img src="../../images/phone12.png" style="width: 35px;height: 35px;"> -->
                        0531-83176606
                    </h2>
                </div>
            </div>
            <div class="cases">
                <h2 class="t_name"><span>{{ this.name }}</span></h2>
                <div class="cases_table">
                    <router-link class="case_item"
                        :to="{ path: '/HzDetails', query: { id: item.aiId, name: item.aiTypeId, title: '行业案例' } }"
                        v-for="(item, index) in aiInfoList" :key="index">
                        <div class="case_left">
                            <img :alt="item.aiTitle" :src="item.aiCoverPath" :title="item.aiTitle">
                        </div>
                        <div class="case_right">
                            <div class="case_t">
                                {{ item.aiTitle }}
                                <span>[ 查看详情 ]</span>
                            </div>
                            <div class="case_d">{{ item.aiContent }}</div>
                            <div class="case_date">发布时间：{{ item.aiIssueDt }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <!-- <div class="tab">
                <h2 class="t_name"><span>{{ this.name }}</span></h2>
                <div class="tab_items">
                    <router-link class="tab_item hyal"
                        :to="{ path: '/HzDetails', query: { id: item.aiId, name: item.aiTypeId,title: '行业案例' } }"
                        v-for="(item, index) in aiInfoList" :key="index">
                        <div class="tab_photo">
                            <img :alt="item.aiTitle" :src="item.aiCoverPath" :title="item.aiTitle">
                        </div>
                        <div class="tab_detail">
                            <h2>
                                <span>{{ item.aiTitle }}</span>
                            </h2>
                            <p>{{ item.aiContent }}</p>
                        </div>
                    </router-link>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzControl',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            image: '',
            number: 0,
            caseTList: [],
            aiInfoList: [],
        };
    },
    computed: {},
    watch: {
        $route() {
            if (this.$router.history.current.query.name !== this.name) {
                this.$router.go();
            }
        }
    },
    methods: {
        onEnterTd(index) {
            this.number = index;
        },
        queryAlType() {
            http.get('/hzAlInfo/aiType', { params: { aiTypeId: this.id } }).then((res) => {
                this.aiInfoList = res.data.data.result;
                this.caseTList = res.data.data.aiType;
                this.aiInfoList.forEach(item => {
                    item.aiCoverPath = this.image + item.aiCoverPath;
                })
                window.localStorage.setItem('alType', JSON.stringify(this.caseTList));
            })
        },
        //禁用Ctrl+C复制和右击
        handleKeyDown(event) {
            if (event.ctrlKey && event.key === 'c') {
                event.preventDefault();
                // 在这里可以添加你自己的逻辑，比如提示用户禁止复制操作
            }
        }
    },
    //禁用Ctrl+C复制和右击
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    created() {
        this.image = http.imageURL
        window.localStorage.setItem('titles', '行业案例');
        this.queryAlType();
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function('event.returnValue=false')
        })
    }
}
</script>

<style>
@import "../../config/Control.css";
</style>


// WEBPACK FOOTER //
// src/views/about/HzHyal.vue